import type { Options, BackgroundAnimation } from './background-animation';
import { backgroundAnimation } from './background-animation';

const available: Array<BackgroundAnimation> = [];
const taken: Array<BackgroundAnimation> = [];

export function retrieveBackgroundAnimation(options: Options) {
  let result: BackgroundAnimation;
  if (available.length > 0) {
    [result] = available.splice(0, 1);
    result.updateOptions(options);
  } else {
    result = backgroundAnimation.init(options);
  }
  taken.push(result);
  return result;
}

export function releaseBackgroundAnimation(animation: BackgroundAnimation) {
  const index = taken.indexOf(animation);
  if (index > -1) {
    animation.release();
    available.push(...taken.splice(index, 1));
  }
}
